import React from 'react';
import { formatDateTime } from '@utils/timeUtils';
import { BASE_IMG_URL } from '@images/imageUrls';
import CommonPopupNew from '@components/commonPopupNew';
import type { ScoreRecord, VCoinRecordLayoutProps } from '../../types';
import styles from './index.module.scss';

class VCoinRecordH5 extends React.Component<VCoinRecordLayoutProps> {
    // 渲染单条 V 币变动记录及其时间。
    renderRecord = (item: ScoreRecord, index: number) => {
        const score = Number(item.this_score || 0);
        const recordTime = item.updated_at ? formatDateTime(item.updated_at) : '';
        return (
            <div className={styles.record} key={item.id ?? `${item.updated_at}-${index}`}>
                {/* 左侧展示变动原因和时间。 */}
                <div className={styles.recordInfo}>
                    <div className={styles.reason}>{item.get_reason || 'V币变动'}</div>
                    <div className={styles.time}>{recordTime}</div>
                </div>
                {/* 右侧展示变动数量和 V 币图标。 */}
                <div className={styles.amountBox}>
                    <span className={`${styles.amount} ${score > 0 ? styles.positive : score < 0 ? styles.negative : ''}`}>
                        {score > 0 ? '+' : ''}{item.this_score}
                    </span>
                    <img src={`${BASE_IMG_URL}/goods/icon2.png`} alt="V币" className={styles.coin} />
                </div>
            </div>
        );
    };

    render() {
        const {
            records, score, loading, hasMore, error, earnTipVisible, weChatBrowserGuideVisible,
            onBack, onOpenEarnTip, onHideEarnTip, onHideWeChatBrowserGuide, onRetry, onOpenAppMall,
        } = this.props;

        return (
            <main className={styles.page}>
                <section className={styles.container}>
                    {/* 余额区域：展示当前 V 币余额和赚取入口。 */}
                    <div className={styles.hero}>
                        <div className={styles.label}>我的V币</div>
                        <div className={styles.balance}>{score}</div>
                        <button className={styles.earn} type="button" onClick={onOpenEarnTip}>
                            去赚取更多V币 <img src={`${BASE_IMG_URL}/goods/jtr3.png`} alt="" className={styles.earnArrow} />
                        </button>
                    </div>
                    {/* 明细列表：覆盖空状态、加载状态、错误重试和分页结束状态。 */}
                    <div className={styles.card}>
                        {records.map(this.renderRecord)}
                        {!loading && !error && records.length === 0 && <div className={styles.status}>亲，您还没有相关记录哦～</div>}
                        {loading && <div className={styles.status}>加载中...</div>}
                        {error && <button className={styles.retry} type="button" onClick={onRetry}>{error}，点击重试</button>}
                        {!loading && !hasMore && records.length > 0 && <div className={styles.status}>没有更多了</div>}
                    </div>
                </section>
                {/* 赚取 V 币弹框：统一使用公共弹框组件处理遮罩、按钮和关闭逻辑。 */}
                <CommonPopupNew variant="h5"
                    visible={earnTipVisible}
                    popupContentBg={true}
                    title="温馨提示"
                    cancelText="取消"
                    confirmText="打开App端"
                    onCancelChange={onHideEarnTip}
                    onConfirmButtonChange={onOpenAppMall}
                >
                    <p className={styles.modalText}>请前往vivo社区App端【V币商城】-【V币任务页】赚取V币吧</p>
                </CommonPopupNew>
                {weChatBrowserGuideVisible && (
                    <div className={styles.weChatBrowserGuide} onClick={onHideWeChatBrowserGuide}>
                        <div className={styles.weChatBrowserGuideTip}>
                            点击右上角选择在默认浏览器中打开
                        </div>
                    </div>
                )}
            </main>
        );
    }
}

export default VCoinRecordH5;
